import React, { useRef, useState } from 'react';

export const FilePicker = ({ title, onChange, fileType }) => {
    console.log(fileType)
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState(null);

  // Validate CSV content based on fileType
  const validateCSV = (text) => {
    const lines = text.split('\n').map(line => line.trim()).filter(Boolean);
    if (fileType === 'premiums') {
 // Expect header row with "age,amount"
      if (lines.length === 0) return false;
      const header = lines[0].split(',').map(col => col.trim().toLowerCase());
      const expected = ['age', 'amount'];
      if (header.length !== expected.length) return false;
      for (let i = 0; i < expected.length; i++) {
        if (header[i] !== expected[i]) return false;
      }
      // Validate subsequent rows: each row must have exactly 2 values: age and amount (both numeric)
      for (let i = 1; i < lines.length; i++) {
        const columns = lines[i].split(',').map(col => col.trim());
        if (columns.length !== expected.length) return false;
        const [age, amount] = columns;
        if (isNaN(age) || isNaN(amount)) return false;
      }
      return true;
    } else if (fileType === 'benefits') {
      // Expect header row with "title,subtitle,category,value"
      if (lines.length === 0) return false;
      const header = lines[0].split(',').map(col => col.trim().toLowerCase());
      const expected = ['title', 'subtitle', 'category', 'value'];
      if (header.length !== expected.length) return false;
      for (let i = 0; i < expected.length; i++) {
        if (header[i] !== expected[i]) return false;
      }
      // Check that every subsequent row has exactly 4 columns
      for (let i = 1; i < lines.length; i++) {
        const columns = lines[i].split(',').map(col => col.trim());
        if (columns.length !== expected.length) return false;
      }
      return true;
    }
    return false;
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        if (validateCSV(text)) {
          setFileName(file.name);
          setError(null);
          onChange(event);
        } else {
          setFileName('');
          setError('Invalid CSV format. Please check the file and try again.');
          // Optionally clear the file input if invalid
          fileInputRef.current.value = '';
        }
      };
      reader.readAsText(file);
    }
  };

  return (
    <div>
      <div
        className='h-[100px] lg:w-[316px] capitalize border border-dashed border-[#8A97AA] text-[#8A97AA] flex text-[12px] text-center font-normal items-center justify-center cursor-pointer rounded-lg'
        onClick={handleClick}
      >
        {title}
      </div>
      <input
        type="file"
        accept=".csv"
        className="hidden"
        ref={fileInputRef}
        onChange={handleFileChange}
      />
      {fileName && (
        <p className="text-sm text-gray-500 mt-2">{fileName}</p>
      )}
      {error && (
        <p className="text-sm text-red-500 mt-2">{error}</p>
      )}
    </div>
  );
};





// import React, { useRef, useState } from 'react';

// export const FilePicker = ({ title, onChange }) => {
//   const fileInputRef = useRef(null);
//   const [fileName, setFileName] = useState('');

//   const handleClick = () => {
//     fileInputRef.current.click();
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       setFileName(file.name);
//       onChange(event);
//     }
//   };

//   return (
//     <div>
//       <div
//         className='h-[100px] w-[316px] capitalize border border-dashed border-[#8A97AA] text-[#8A97AA] flex text-[12px] text-center font-normal items-center justify-center cursor-pointer rounded-lg'
//         onClick={handleClick}
//       >
//         {title}
//       </div>
//       <input
//         type="file"
//         accept=".csv"
//         className="hidden"
//         ref={fileInputRef}
//         onChange={handleFileChange}
//       />
//       {fileName && (
//         <p className="text-sm text-gray-500 mt-2">{fileName}</p>
//       )}
//     </div>
//   );
// };
